import { createSlice } from "@reduxjs/toolkit";

const socketSlice = createSlice({
  name: "socket",
  initialState: { socket: null, isConnected: false, thread: [], busSpeed: 0 },
  reducers: {
    setSocket(state, action) {
      state.socket = action.payload;
      state.isConnected = Boolean(action.payload);
    },
    clearSocket(state) {
      state.socket = null;
      state.isConnected = false;
    },
    setThread(state, action) {
      state.thread = action.payload;
    },
    setStatus(state, action) {
      state.isConnected = action.payload;
    },
    setBusSpeed(state, action) {
      state.busSpeed = action.payload;
    },
  },
});

export const { setSocket, clearSocket, setThread, setStatus, setBusSpeed } =
  socketSlice.actions;

export const socketReducer = socketSlice.reducer;
